import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { ValidateDataErrorDirective } from '@df/ui/form/validate-data-error.directive';
import { Subscription } from 'rxjs/internal/Subscription';
import { CheckoutFormComponent } from '../../../checkout/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/checkout-step.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../../ui/form/mui-input.directive';
import { SAGEPAY_PI_SAVED_CARD_STATUS_DISPLAY_SUBMITTED, SagepayPiServiceDecorator } from './sagepay.service.decorator';

@Component({
    selector: 'sagepay-pi-saved-card-status',
    templateUrl: './sagepay-pi-saved-card-status.html',
    standalone: true,
    imports: [FormsModule, InputWrapBodyDirective, InputWrapComponent, MuiInputDirective, ValidateDataErrorDirective]
})
export class SagepayPiSavedCardStatusComponent implements OnChanges, OnInit, OnDestroy {
    protected subscriptions = new Subscription();

    private _cvc?: string;

    @Input()
    card: CreditCard;

    @ViewChild('stepForm', { static: false })
    form: NgForm;

    constructor(
        protected sagepayPiService: SagepayPiServiceDecorator,
        protected app: App,
        protected checkoutStepComponent: CheckoutStepComponent,
        public checkoutFormComponent: CheckoutFormComponent
    ) {}

    ngOnInit() {
        this.subscriptions.add(this.sagepayPiService.dataUpdate.subscribe(() => this.onDataUpdate()));
        this.subscriptions.add(this.app.events.on(SAGEPAY_PI_SAVED_CARD_STATUS_DISPLAY_SUBMITTED).subscribe(() => this.updateForm(true)));
        this.subscriptions.add(this.app.events.on(Checkout.EVENTS.StepChange).subscribe(() => this.updateForm(false)));
    }

    ngOnChanges() {
        this.onDataUpdate();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected updateForm(to: boolean): void {
        this.form['submitAttempt'] = to;
        this.form.ngSubmit.emit();
    }

    get cardCode(): string | undefined {
        return this.card?.code;
    }

    get cvc(): string {
        return this._cvc;
    }

    set cvc(value: string) {
        this._cvc = value;
        if (this.cardCode) {
            this.sagepayPiService.setCode(this.cardCode, value);
        }
    }

    protected onDataUpdate(): void {
        if (this.checkoutFormComponent.status.superBusy) {
            return;
        }
        const cardCode = this.cardCode;
        if (cardCode) {
            this._cvc = this.sagepayPiService.getCode(cardCode);
        } else {
            this._cvc = '';
        }
    }
}
